
import Vue from 'vue' // Vue本体の読み込み
import App from './App.vue' // ルートコンポーネントの読み込み
import vuetify from './plugins/vuetify';//UIフレームワーク（Vuetify）の設定
import router from './router.js'//router.jsをインポート
import axios from 'axios'//HTTPクライアントライブラリ
import store from '@/store'//状態管理
import VueApexCharts from 'vue-apexcharts'//VueApexChartsの設定

//vueに追加
Vue.use(VueApexCharts)
//Vueコンポーネントとして登録→テンプレート内で<apexchart>タグを使用してグラフを表示できるようになる
Vue.component('apexchart', VueApexCharts)

//Vueのログを非表示にする設定
Vue.config.productionTip = false

// Axiosの設定
//JavaScript を使って、外部のサーバーとデータのやり取り（API 通信）を行うためのライブラリ
Vue.use({
  install (Vue) {
    //Vue.prototype.$axios→Vueインスタンス全体で$axiosを利用できるようにする
    Vue.prototype.$axios = axios.create({
      //ローカル環境
      //baseURL: 'http://localhost:3000/'
      //本番環境
      baseURL: '/'
    })
  }
})

//Vueインスタンスの作成（追加するのは、Node.jsのモジュールであるVuetify、Router、Store）
//インスタンスに追加するのは、Vuetify（UIフレームワーク）、Router（ルーティング機能）、Store（状態管理）
//render: h => h(App)→ルートコンポーネントApp.vueを描画するための関数

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
